const NOTIFICATION_STRINGS = {
  PLAN_SAVED: 'Plan saved.',
  PLAN_UPDATED: 'Changes saved.',
  PLAN_DELETED: 'Plan deleted.',
  DUPLICATE_BUTTON: 'Duplicate',
  // FR-036: Plans has a single "Download PDF" action (no English/Spanish
  // split, unlike Applications/Work Orders/Invoices), matching the label
  // already on Plans' own action menu.
  PRINT_PDF_BUTTON: 'Download PDF',
  ERROR_TITLE: 'Unable to save Plan.',
  ERROR_MESSAGE:
    'An error prevented your Plan from being saved. Please try again.',
  DELETE_ERROR_TITLE: 'Unable to delete Plan.',
  DELETE_ERROR_MESSAGE:
    'An error prevented your Plan from being deleted. Please try again.',
  CONTACT_BUTTON: 'Contact Support'
};

export default NOTIFICATION_STRINGS;
